import script from "./MenuTarefasAcao.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuTarefasAcao.vue?vue&type=script&setup=true&lang=js"

import "./MenuTarefasAcao.vue?vue&type=style&index=0&id=4dfc4bd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dfc4bd4"]])

export default __exports__